interface ServicesSchema {
    pageTitle: string;
    pageDescription: string;
    pageKeywords: string;
    canonicalUrl: string;
    servicesSchema: {
        "@context": string;
        "@type": string;
        name: string;
        description: string;
        provider: {
            "@type": string;
            name: string;
        };
        areaServed: string;
        serviceType: string;
    };
    servicesSchemaJson: string;
}

const pageTitle = "Complete Home Care Services | Personal Care & Companion Care Dallas";
const pageDescription = "Comprehensive home care services including personal care, companion care, dementia care, Alzheimer's care, respite care, and 24-hour home care services in Dallas-Fort Worth.";
const pageKeywords = "personal care services, companion care services, dementia care services, Alzheimer's care services, respite care services, 24-hour home care services, live-in care services";
const canonicalUrl = "https://masahillshealthservices.com/services";
const servicesSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Home Care Services",
    "description": "Comprehensive in-home care services for seniors and elderly",
    "provider": {
        "@type": "Organization",
        "name": "MASA HILLS Health Services"
    },
    "address": {
        "@type": "3410 Texas Dr, Sachse, TX 75048",
        "streetAddress": "3410 Texas Dr",
        "addressLocality": "Sachse",
        "addressRegion": "TX",
        "postalCode": "75048",
        "addressCountry": "US"
    },
    "areaServed": "Dallas-Fort Worth, Texas",
    "serviceType": "Healthcare"
};
const servicesSchemaJson = JSON.stringify(servicesSchema, null, 2);

const ServicesSchemaData: ServicesSchema = {
    pageTitle,
    pageDescription,
    pageKeywords,
    servicesSchema,
    servicesSchemaJson,
    canonicalUrl
};

export default ServicesSchemaData;